const MCE_NAMESPACE_CLASSNAME = 'mce-layer-root';
let mceRootNode;

/**
 * This creates and reuses a global DOM `mceRootNode` that can be passed down to
 * UIComponent modals & panels for tinymce namespacing. This solution replaces
 * the needed for threading `className="mce-*"`. Note we still need to pass down
 * `dropdownClassName="mce-*"` because UIComponent popovers rendered within
 * the `mce-layer-root` are placed in a separate tether layer that's a sibling
 * to our mce `mceRootNode`.
 */
export const getMceRootNode = () => {
  if (!mceRootNode) {
    mceRootNode = document.createElement('div');
    mceRootNode.className = MCE_NAMESPACE_CLASSNAME;
  }

  // Always relocate the `mceRootNode` to the end of the body to ensure z-index
  // prioritization because other ui-layers may have rendered further down in
  // the DOM since the previous `mceRootNode` usage.
  document.body.appendChild(mceRootNode);
  return mceRootNode;
};